import React, { useEffect, useState } from 'react'
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { setShowList } from '../redux/modules/showList/slice';
import { usePermissions } from '../hooks/usePermissions';

const ListFormHoc = ({ List, Form, showBtn = true, initialShowList = true, initialItemData = null, writeModule = null }) => {
  const dispatch = useDispatch();
  const { currentBranch } = useSelector(state => state.branch)
  const { showList } = useSelector(state => state.reduxShowList)
  const { canWrite } = usePermissions();
  const [itemData, setItemData] = useState(initialItemData || {});
  const [currentPage, setCurrentPage] = useState(1);
  const toggleList = () => { dispatch(setShowList(!showList))};

  // When the page declares which permission its Add form needs, grey the
  // button out (with the reason) for read-only roles instead of letting
  // them open a form whose save will be rejected server-side. The button
  // doubles as "Cancel" in form mode, so only the Add state is gated.
  const writeAllowed = !writeModule || canWrite(writeModule);
  const addDisabled = showList && !writeAllowed;

  useEffect(() => {
    if (currentBranch) {
      dispatch(setShowList(initialShowList));
    }
  }, [dispatch, currentBranch, initialShowList]);

  useEffect(() => {
    if (initialItemData) {
      setItemData(initialItemData);
    }
  }, [initialItemData]);

  return (
    <>
      {showBtn &&
        <Box textAlign={'right'} mb={3} mt={4}>
          <Tooltip title={addDisabled ? 'You have read-only access — adding is disabled for your role.' : ''} arrow>
            <span>
              <Button className='commonBtn' variant="contained" disabled={addDisabled} onClick={() => { toggleList(); setItemData({}) }} startIcon={showList ? <AddIcon /> : <CloseIcon />}> {showList ? "Add" : "Cancel"} </Button>
            </span>
          </Tooltip>
        </Box>
      }
      {showList ? <List setItemData={setItemData} toggleList={toggleList} itemData={itemData} setCurrentPage={setCurrentPage} currentPage={currentPage}/> : <Form itemData={itemData} setItemData={setItemData} toggleList={toggleList} />}
    </>
  )
}

export default ListFormHoc;
